import React from 'react';
import Header from './Header';
import Code from './Code';
import Result from './Result';

const Home = () => {
    return (
        <div>
            <Header />
            <Code />
            <Result />
        </div>
    )
}

export default Home;